module.exports = __webpack_public_path__ + "img/17.95562d8a.jpg";